import { styled } from '@mui/material';

import ResultHiddenIcon from '../../../../../../../icons/ResultHiddenIcon';

export const HideResultsIcon = styled(ResultHiddenIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(64),
  color: theme.palette.error.main,
}));
